import Layout from '@/layout/index.vue';
var baseRouter = {
  path: '/base',
  name: 'Base',
  component: Layout,
  meta: {
    title: '基础设置'
  },
  children: [{
    path: 'pkg',
    name: 'BasePkg',
    component: function component() {
      return import('@/views/base/pkg/index.vue');
    },
    meta: {
      title: '渠道管理'
    }
  }, {
    path: 'game',
    name: 'BaseGame',
    component: function component() {
      return import('@/views/base/game/index.vue');
    },
    children: [{
      path: 'supplier',
      component: function component() {
        return import('@/views/base/game/supplier/index.vue');
      },
      name: 'BaseGameSupplier',
      meta: {
        title: '游戏供应商'
      }
    }, {
      path: 'factory',
      component: function component() {
        return import('@/views/base/game/factory/index.vue');
      },
      name: 'BaseGameFactory',
      meta: {
        title: '游戏厂商'
      }
    }]
  }, {
    path: 'sms',
    name: 'sms',
    component: function component() {
      return import('@/views/base/sms/index.vue');
    },
    children: [{
      path: 'channel',
      component: function component() {
        return import('@/views/base/sms/channel/index.vue');
      },
      name: 'SmsList',
      meta: {
        title: '短信通道'
      }
    }, {
      path: 'record',
      component: function component() {
        return import('@/views/base/sms/record/index.vue');
      },
      name: 'SmsRecord',
      meta: {
        title: '短信记录'
      }
    }]
  }, {
    path: 'picture',
    name: 'picture',
    component: function component() {
      return import('@/views/base/picture/index.vue');
    },
    meta: {
      title: '素材管理'
    }
  }]
};
export default baseRouter;